import { IExperimentStartPayload, IExperimentStatusPayload } from '../models/SiteReliabilityModels';
import ISiteReliabilityState from '../store/state/SiteReliabilityState';
import { API_ROUTE } from './ApiRoute';
import ApiService from './ApiService';
import ApiServiceBase from './ApiServiceBase';
import { ServerType, ServiceType } from './ServiceType.data';

export class SiteReliabilityService {
  private readonly prometheusService: ApiServiceBase = new ApiService(
    ServiceType.None,
    ServerType.prometheus,
  );
  private readonly faultInjectionStatusService: ApiServiceBase = new ApiService(
    ServiceType.None,
    ServerType.faultInjectionStatus,
  );

  private readonly serviceLocal: ApiServiceBase = new ApiService(
    ServiceType.None,
    ServerType.tangra,
  );

  public triggerExperiment(
    data: IExperimentStartPayload,
  ): Promise<ISiteReliabilityState> | ISiteReliabilityState {
    return this.serviceLocal.post(
      { route: [API_ROUTE.SITE_RELIABILITY.BASE, API_ROUTE.SITE_RELIABILITY.TRIGGER] },
      data,
    );
  }

  public getExperimentStatus(
    data: IExperimentStatusPayload,
  ): Promise<ISiteReliabilityState> | ISiteReliabilityState {
    return this.serviceLocal.post(
      { route: [API_ROUTE.SITE_RELIABILITY.BASE, API_ROUTE.SITE_RELIABILITY.GET_STATUS] },
      data,
    );
  }

  public getPrometheusData(): Promise<ISiteReliabilityState[]> | ISiteReliabilityState[] {
    return this.prometheusService.post({ route: [API_ROUTE.SITE_RELIABILITY.PROMETHEUS] }, {});
  }

  public getFisStatusString(): Promise<string> | string {
    return this.faultInjectionStatusService.get({ route: [API_ROUTE.SITE_RELIABILITY.PROMETHEUS] });
  }
}

const siteReliabilityService = new SiteReliabilityService();
export default siteReliabilityService;
